/* /library — kept for backwards-compatible deep links. Mounts the
 * unified hub on the Library tab. The user is on a single page; the
 * URL is just a different entry point. */

import { RulesHub } from "../components/rules/RulesHub";

export default function Library(): JSX.Element {
  return <RulesHub initialTab="library" />;
}
